<template>
	<div ref="box">
		<div style="display: flex;flex-direction: column;align-items: center;justify-content: center;max-width: 100%;">
			<div style="white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;"
				:style="{
				color:selectdItem.compontChildren[0].layoutConfig.titColor,
				fontFamily:selectdItem.compontChildren[0].layoutConfig.titleFontFamily,
				fontSize:selectdItem.compontChildren[0].layoutConfig.titleSize + 'px',
				fontWeight:selectdItem.compontChildren[0].layoutConfig.isBold?'bold':'',
			}">
				{{selectdItem.compontChildren[0].layoutConfig.tit}}
			</div>

			<el-form :style="{
				marginTop:selectdItem.compontChildren[0].layoutConfig.titleMarTop + 'px',
				 width:getIptWidth(selectdItem),
			 }" style="margin-top: 15px;" :model="ruleForm" label-position="top" :rules="rules" ref="ruleForm"
				class="demo-ruleForm">
				<div v-for="(item,index) in selectdItem.compontChildren[0].layoutConfig.sort" :key="index">
					<el-form-item :style="{
						'--iptMarBto':selectdItem.compontChildren[0].layoutConfig.iptMarBto + 'px',
						'--titMarBto':selectdItem.compontChildren[0].layoutConfig.titMarBto + 'px',
						'--labelFontBold':selectdItem.compontChildren[0].layoutConfig.isLabelBold?'bold':'',
						'--labelFontSize':selectdItem.compontChildren[0].layoutConfig.labelFontSize + 'px',
						'--labelColor':selectdItem.compontChildren[0].layoutConfig.labelColor
					}" v-if="selectdItem.compontChildren[0].layoutConfig.name.show && item.value == 'name'" :label="$t('h.name')"
						:prop="selectdItem.compontChildren[0].layoutConfig.name.isRequire?'name':''">
						<el-input :style="{
							'--borIptDedaultColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptDedaultColor}`,
								'--borIptColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptColor}`,
									'--borIptHoverColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptHoverColor}`,
						 }" :size="selectdItem.compontChildren[0].layoutConfig.size" :placeholder="$t('h.peleaseIpt')"
							v-model="ruleForm.name"></el-input>
					</el-form-item>

					<el-form-item :style="{
						 '--iptMarBto':selectdItem.compontChildren[0].layoutConfig.iptMarBto + 'px',
						 '--titMarBto':selectdItem.compontChildren[0].layoutConfig.titMarBto + 'px',
						 '--labelFontBold':selectdItem.compontChildren[0].layoutConfig.isLabelBold?'bold':'',
						 '--labelFontSize':selectdItem.compontChildren[0].layoutConfig.labelFontSize + 'px',
					 	'--labelColor':selectdItem.compontChildren[0].layoutConfig.labelColor
					 }" v-if="selectdItem.compontChildren[0].layoutConfig.email.show && item.value == 'email'" :label="$t('h.email')"
						:prop="selectdItem.compontChildren[0].layoutConfig.email.isRequire?'email':''">
						<el-input :style="{
							'--borIptDedaultColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptDedaultColor}`,
								'--borIptColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptColor}`,
									'--borIptHoverColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptHoverColor}`,
						 }" :size="selectdItem.compontChildren[0].layoutConfig.size" :placeholder="$t('h.peleaseIpt')"
							v-model="ruleForm.email"></el-input>
					</el-form-item>

					<el-form-item :style="{
						 '--iptMarBto':selectdItem.compontChildren[0].layoutConfig.iptMarBto + 'px',
						 '--titMarBto':selectdItem.compontChildren[0].layoutConfig.titMarBto + 'px',
						 '--labelFontBold':selectdItem.compontChildren[0].layoutConfig.isLabelBold?'bold':'',
						 '--labelFontSize':selectdItem.compontChildren[0].layoutConfig.labelFontSize + 'px',
					 	'--labelColor':selectdItem.compontChildren[0].layoutConfig.labelColor
					 }" v-if="selectdItem.compontChildren[0].layoutConfig.phone.show && item.value == 'phone'" :label="$t('h.phone')"
						:prop="selectdItem.compontChildren[0].layoutConfig.phone.isRequire?'phone':''">
						<el-input :style="{
							'--borIptDedaultColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptDedaultColor}`,
								'--borIptColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptColor}`,
									'--borIptHoverColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptHoverColor}`,
						 }" :size="selectdItem.compontChildren[0].layoutConfig.size" :placeholder="$t('h.peleaseIpt')"
							v-model="ruleForm.phone"></el-input>
					</el-form-item>

					<el-form-item :style="{
						 '--iptMarBto':selectdItem.compontChildren[0].layoutConfig.iptMarBto + 'px',
						 '--titMarBto':selectdItem.compontChildren[0].layoutConfig.titMarBto + 'px',
						 '--labelFontBold':selectdItem.compontChildren[0].layoutConfig.isLabelBold?'bold':'',
						 '--labelFontSize':selectdItem.compontChildren[0].layoutConfig.labelFontSize + 'px',
					 	'--labelColor':selectdItem.compontChildren[0].layoutConfig.labelColor
					 }" v-if="selectdItem.compontChildren[0].layoutConfig.address.show  && item.value == 'address'"
						:label="$t('h.address')"
						:prop="selectdItem.compontChildren[0].layoutConfig.address.isRequire?'address':''">
						<el-input :style="{
							'--borIptDedaultColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptDedaultColor}`,
								'--borIptColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptColor}`,
									'--borIptHoverColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptHoverColor}`,
						 }" :size="selectdItem.compontChildren[0].layoutConfig.size" :placeholder="$t('h.peleaseIpt')"
							v-model="ruleForm.address"></el-input>
					</el-form-item>

					<el-form-item :style="{
						 '--iptMarBto':selectdItem.compontChildren[0].layoutConfig.iptMarBto + 'px',
						 '--titMarBto':selectdItem.compontChildren[0].layoutConfig.titMarBto + 'px',
						 '--labelFontBold':selectdItem.compontChildren[0].layoutConfig.isLabelBold?'bold':'',
						 '--labelFontSize':selectdItem.compontChildren[0].layoutConfig.labelFontSize + 'px',
					 	'--labelColor':selectdItem.compontChildren[0].layoutConfig.labelColor
					 }" v-if="selectdItem.compontChildren[0].layoutConfig.content.show && item.value == 'content'"
						:label="selectdItem.compontChildren[0].layoutConfig.content.title?selectdItem.compontChildren[0].layoutConfig.content.title: $t('h.comment')"
						:prop="selectdItem.compontChildren[0].layoutConfig.content.isRequire?'content':''">
						<el-input :rows="selectdItem.compontChildren[0].layoutConfig.content.row" type="textarea"
							:style="{
								'--borIptDedaultColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptDedaultColor}`,
									'--borIptColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptColor}`,
										'--borIptHoverColor':`solid 1px ${selectdItem.compontChildren[0].layoutConfig.borIptHoverColor}`,
						 	 width:getIptWidth(selectdItem)
						 }" :size="selectdItem.compontChildren[0].layoutConfig.size" :placeholder="$t('h.peleaseIpt')"
							v-model="ruleForm.content "></el-input>
					</el-form-item>
				</div>


				<!-- <el-form-item :label="' '">
				</el-form-item> -->

			</el-form>
			<button @click="send"
				style="border: solid 0px #fff;background-color: rgb(0 0 0 / 0%);cursor: pointer;border-radius: 4px;display: flex;align-items: center;justify-content: center;font-size: 18px;margin-top: 6px;"
				@mouseleave.stop.prevent="enterBtn = false" @mouseenter.stop.prevent="enterBtn = true" :style="{
					...getBtnBorder(),
				fontSize:selectdItem.compontChildren[0].layoutConfig.btn.fontSize + 'px',
				...getBtnColor(),
				...getBgBtn(),
				height:selectdItem.compontChildren[0].layoutConfig.btn.size == ''?'40px':selectdItem.compontChildren[0].layoutConfig.btn.size == 'medium'?'36px':'28px',
				width:selectdItem.compontChildren[0].layoutConfig.btn.width + 'px'
			}">
				<i v-if="loading" class="el-icon-loading"></i>
				<span style="margin-left: 4px;">
					{{$t('h.confirm')}}
				</span>
			</button>
		</div>
	</div>
</template>

<script>
	import {
		getmessageSend
	} from '../../api/all.js'
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				loading: false,
				innerWidth: 0,
				enterBtn: false,
				ruleForm: {
					email: "",
					name: "",
					phone: "",
					address: "",
					title: "",
					content: ""
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}, ],
					email: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}, 
					{
						validator: this.checkEmail,
						trigger: 'blur'
					}
					
					],
					phone: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}, ],
					address: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}, ],
					content: [{
						required: true,
						message: this.$t('h.peleaseIpt'),
						trigger: 'blur'
					}, ],

				}
			}
		},
		watch: {
			equipment: {
				handler(newV, oldV) {
					if (this.$refs.box) {
						this.innerWidth = this.$refs.box.offsetWidth;
						console.log('this.innerWidth', this.innerWidth)
						
					}
				}
			},
			selectdItem: {
				deep: true,
				handler(newV, oldV) {
					if (this.$refs.box) {
						this.innerWidth = this.$refs.box.offsetWidth;
						console.log('this.innerWidth', this.innerWidth)
					}
				}
			}
		},
		mounted() {
			this.innerWidth = this.$refs.box.offsetWidth;
			console.log('this.innerWidth1', this.innerWidth)
		},
		methods: {
			checkEmail(rule, value, cb) {
				//验证邮箱的正则表达式
				const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
				if (regEmail.test(value)) {
					//合法的邮箱
					return cb();
				}
				//邮箱不合法
				cb(new Error(this.$t('h.errorEmail')));
			},
			async send() {
				if (this.type == 'design') {
					return
				}
				this.$refs['ruleForm'].validate(async (valid) => {
					if (valid) {
						try {
							this.loading = true
							if (this.selectdItem.compontChildren[0].layoutConfig.tit) {
								this.ruleForm.title = this.selectdItem.compontChildren[0].layoutConfig.title
							}
							let data = await getmessageSend({
								...this.ruleForm
							})
							this.loading = false
							this.$message.success(data.data.message)
						} catch (e) {
							this.loading = false
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});


			},
			getIptWidth(selectdItem) {
				if (this.equipment == 'pc') {
					return (selectdItem.compontChildren[0].layoutConfig.width - selectdItem.preStyle.border.borderSize[1] -
						selectdItem.preStyle.border.borderSize[3] - selectdItem.preStyle.padding[1] - selectdItem
						.preStyle.padding[3] - selectdItem.preStyle.margin[1] - selectdItem
						.preStyle.margin[3]) + 'px'
				} else {
					if (this.type == 'design') {
						return (selectdItem.compontChildren[0].layoutConfig.width - selectdItem.preStyle.border.borderSize[
								1] -
							selectdItem.preStyle.border.borderSize[3] - selectdItem.preStyle.padding[1] - selectdItem
							.preStyle.padding[3] - selectdItem.preStyle.margin[1] - selectdItem
							.preStyle.margin[3]) + 'px'
					} else {
						return (selectdItem.compontChildren[0].layoutConfig.width - selectdItem.preStyle.border.borderSize[
								1] -
							selectdItem.preStyle.border.borderSize[3] - selectdItem.preStyle.padding[1] - selectdItem
							.preStyle.padding[3] - selectdItem.preStyle.margin[1] - selectdItem
							.preStyle.margin[3]) + 'px'
					}
				}
			},


			getBtnBorder() {
				let border = this.selectdItem.compontChildren[0].layoutConfig.btn.border
				console.log('borderborderborder1', border)
				if (border.type && border.color) {
					let style = {}
					style.borderTop =
						`${border.type} ${border.borderSize[0]}px ${border.color}`
					style.borderLeft =
						`${border.type} ${border.borderSize[1]}px ${border.color}`
					style.borderBottom =
						`${border.type} ${border.borderSize[2]}px ${border.color}`
					style.borderRight =
						`${border.type} ${border.borderSize[3]}px ${border.color}`
					return style
				}
			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getBtnColor() {
				let style = {}
				if (this.enterBtn) {
					if (this.selectdItem.compontChildren[0].layoutConfig.btn.hoverColor) {
						return {
							color: this.selectdItem.compontChildren[0].layoutConfig.btn.hoverColor
						}
					}
				}
				if (this.selectdItem.compontChildren[0].layoutConfig.btn.fontColor) {
					return {
						color: this.selectdItem.compontChildren[0].layoutConfig.btn.fontColor
					}
				}
			},
			getBgBtn() {
				let style = {}
				console.log('enterBtnenterBtn', this.enterBtn)
				if (this.enterBtn) {
					if (this.selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgtype == 'color') {
						if (this.selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.color) {
							style.backgroundColor = this.selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.color
							return style
						}
					} else {
						if (this.selectdItem.compontChildren[0].layoutConfig.btn.hoverBg.bgGradient) {
							style = {
								...this.cssStringToObject(this.selectdItem.compontChildren[0].layoutConfig.btn.hoverBg
									.bgGradient)
							}
						}
						return style
					}
				}
				if (this.selectdItem.compontChildren[0].layoutConfig.btn.bg.bgtype == 'color') {
					if (this.selectdItem.compontChildren[0].layoutConfig.btn.bg.color) {
						style.backgroundColor = this.selectdItem.compontChildren[0].layoutConfig.btn.bg.color
						return style
					}
				} else {
					if (this.selectdItem.compontChildren[0].layoutConfig.btn.bg.bgGradient) {
						style = {
							...this.cssStringToObject(this.selectdItem.compontChildren[0].layoutConfig.btn.bg
								.bgGradient)
						}
					}
					return style
				}

			}
		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-input__inner {
		border: var(--borIptDedaultColor);
	}

	::v-deep .el-input__inner:hover {
		border: var(--borIptHoverColor);
	}

	::v-deep .el-input__inner:focus {
		border: var(--borIptColor);
	}

	::v-deep .el-textarea__inner:focus {
		border: var(--borIptColor);
	}

	::v-deep .el-textarea__inner:hover {
		border: var(--borIptHoverColor);
	}

	::v-deep .el-textarea__inner {
		border: var(--borIptDedaultColor);
	}

	::v-deep .el-form-item {
		margin-bottom: var(--iptMarBto);

		.el-form-item__label {
			padding: 0px 0px 0px 0px;
			line-height: 0px;
			margin-bottom: var(--titMarBto);

			color: var(--labelColor);
			font-size: var(--labelFontSize);
			font-weight: var(--labelFontBold);
		}
	}
</style>